import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import {
	DocumentCategory as objectPayload,
	DocumentCategoryAddPayload as objectAddPayload,
	DocumentCategoryEditPayload as objectEditPayload,
	DocumentCategoryForm as objectForm
} from './document-category.interface';
import { catchError, map, throwError } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class DocumentCategoryService {

	private serviceName = 'DocumentCategoryService';

	private token!: string;
	private basePath = environment.interop.basePath;

	public getListDTUrl =
		this.basePath +
		environment.interop.autorizatiiComerciale.nomenclatoare.documentCategory.listDT

	private getListUrl =
		this.basePath +
		environment.interop.autorizatiiComerciale.nomenclatoare.documentCategory.list

	private oneUrl =
		this.basePath +
		environment.interop.autorizatiiComerciale.nomenclatoare.documentCategory.one

	private updateUrl =
		this.basePath +
		environment.interop.autorizatiiComerciale.nomenclatoare.documentCategory.update

	private storeUrl =
		this.basePath +
		environment.interop.autorizatiiComerciale.nomenclatoare.documentCategory.store

	private deleteUrl =
		this.basePath +
		environment.interop.autorizatiiComerciale.nomenclatoare.documentCategory.delete

	private clearCacheUrl = this.basePath + environment.interop.autorizatiiComerciale.nomenclatoare.documentCategory.clearCache;

	private httpOptions: any;

	constructor(private http: HttpClient) { }

	setToken(token: string) {
		this.token = token;
		this.httpOptions = {
			headers: new HttpHeaders({
				'Content-Type': 'application/json',
				Accept: 'application/json',
				Authorization: `Bearer ${this.token}`,
			}),
		};
	}

	clearCache() {
		return this.http.get(this.clearCacheUrl, this.httpOptions);
	}

	update(data: objectEditPayload) {
		return this.http.put(
			this.updateUrl,
			data,
			this.httpOptions
		);
	}

	store(data: objectAddPayload) {
		return this.http.post(
			this.storeUrl,
			data,
			this.httpOptions
		);
	}

	delete(id: number) {
		return this.http.delete(this.deleteUrl + id);
	}

	one(id: number) {
		return this.http.get(this.oneUrl + id, this.httpOptions);
	}

	getRecordsList() {
		return this.http
			.get<{ errors: boolean; data: any[]; status_code: number }>(
				this.getListUrl
			)
			.pipe(
				map((response) =>
					response.data.map((item) => ({
						id: item.id,
						name: item.name,
					}))
				),
				catchError((error) => {
					console.error('Error in get request with service ' + this.serviceName, error);
					return throwError(error);
				})
			);
	}

}
